'use client';

import { useState } from 'react';
import GearTypePolicyModal from '@/components/ui/GearTypePolicyModal/GearTypePolicyModal';
import TonePolicyNoticeModal from '@/components/ui/TonePolicyNoticeModal/TonePolicyNoticeModal';
import type { OwnerNotices } from '@/utils/tone-policy/notice';

/** The owner's profile modals, one at a time: tone notices first, then the gear type policy. */
const ProfileModals = ({
  notices,
  showGearTypePolicy,
}: {
  notices: OwnerNotices;
  showGearTypePolicy: boolean;
}) => {
  const [noticesDone, setNoticesDone] = useState(notices.tones.length === 0);

  return (
    <>
      {!noticesDone && (
        <TonePolicyNoticeModal notices={notices} onDone={() => setNoticesDone(true)} />
      )}
      {noticesDone && showGearTypePolicy && <GearTypePolicyModal />}
    </>
  );
};

export default ProfileModals;
